var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":_vm.size,"height":_vm.size,"fill":"none","stroke":_vm.color,"stroke-width":_vm.stroke,"stroke-linecap":"round","stroke-linejoin":"round"}},[_c('use',_vm._b({},'use',{
            'xlink:href': '#' + _vm.name
        },false))])
}
var staticRenderFns = []

export { render, staticRenderFns }